import { ActionConstants } from '../constants/actions';
import { ModuleConstants } from '../constants/modules';
import { RoleConfigStore } from '../store';
import { HasPermissionHookInterface } from './types';

const useHasPermission: HasPermissionHookInterface = () => {
  const roleConfig = RoleConfigStore((state) => state.roleConfig);
  const roleConfigActions = RoleConfigStore((state) => state.roleConfigActions);
  return {
    hasActionPermission: ({ actionId }) => {
      if (actionId === ActionConstants.PUBLIC_ACTION_ID) {
        return true;
      }
      if (actionId && roleConfigActions) {
        const action = roleConfigActions[actionId];
        return action?.isAccessible ?? false;
      }
      return false;
    },

    hasModulePermission: ({ moduleId }) => {
      if (moduleId === ModuleConstants.PUBLIC_MODULE_ID) {
        return true;
      }
      if (moduleId && roleConfig) {
        const module = roleConfig[moduleId];
        return module?.isAccessible ?? false;
      }
      return false;
    },
  };
};

export default useHasPermission;
